import React from "react";
import { Modal } from "antd";
export const DisasterPortalModal = ({
  module,
  handleSave,
  handleCancel,
  open,
  handleChange,
  data
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Add {module}</h3>

        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">
            Name <span style={{ color: "red" }}>*</span>
          </h3>
          <input
            className="roleInput"
            placeholder="Name"
            name="Name"
            value={data && data.Name}
            id="Name"
            onChange={(e) => {
              e.preventDefault();
              handleChange(e.target.name, e.target.value);
            }}
          />
        </div>

        <div style={{ marginBottom: "8px" }}>
          URL <span style={{ color: "red" }}>*</span>
          <input
            className="roleInput"
            placeholder="URL"
            name="URL"
            value={data && data.URL}
            id="URL"
            onChange={(e) => {
              e.preventDefault();
              handleChange(e.target.name, e.target.value);
            }}
          />
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.URL || !data.Name}
            onClick={() => {
              handleSave(module);
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
